export default "__VITE_ASSET__21d4a8fe__"